const LocalStorage = {
  getJSONValue: (key: string): Record<string, unknown> => {
    const value = `${window.localStorage.getItem(key)}`;
    if (value === "null") {
      return {};
    }
    return JSON.parse(value);
  },
  setJSONValue: (key: string, value: Record<string, unknown>): void =>
    window.localStorage.setItem(key, JSON.stringify(value)),
  setItem: (key: string, value: string): void =>
    window.localStorage.setItem(key, value),
  getItem: (key: string): string | null => window.localStorage.getItem(key),
  removeItem: (key: string): void => window.localStorage.removeItem(key),
  clear: (): void => window.localStorage.clear(),
};

export default LocalStorage;
